import { createContext } from "react"

import type { SelectProps } from "./SelectProps"

const SelectContext = createContext<SelectProps>(null as any)

export default SelectContext
